<div id="footer" [ngClass]="{'wrapper': true, 'bottom-footer' :!isTask}">
    <div class="wrapper-size">

        <ul class="footer-nav">
            <li class="footer-logo">
                <span></span>
            </li>
            <li *ngIf="showDetail">
                <a href="https://www.esunbank.com/zh-tw/about/announcement/announcement?i=eYxNfOekAkKLtZwoUwDqaw&p=9WLFRe74B0ikiWlxA46w8Q&d=HA4k102TJkG2QuRj6K5Wtg"
                    target="_blank" target="_blank">{{msgTitle1}}</a>
            </li>
            <li *ngIf="showDetail">
                <a (click)="openFaqPopup($event)">{{msgTitle2}}</a>
            </li>
            <li *ngIf="showDetail">
                <a href="https://www.esunbank.com/zh-tw/about/announcement/legal-disclaimers/report"
                    target="_blank">{{msgTitle3}}</a>
            </li>
            <li *ngIf="showDetail">
                <a href="https://accessible.esunbank.com.tw/Accessibility/Index" target="_blank">{{msgTitle4}}</a>
            </li>
            <li class="footer-copyright">
                <span>©E.SUN BANK</span>
            </li>

        </ul>
    </div>
</div>

<!--
<ccmotlgin-faq-poopup [display]="showFaqPopup" [viewForm]="faqPopupViewForm" (callback)="closeFaqPopup($event)">
</ccmotlgin-faq-poopup>
-->